<bw-action-article-legacy *ngIf="partnerIntro$ | async as partnerIntro; else spinner">
  <div header-actions>
    <ui-nav-exit-back
      [trackingDetail]="{ event_name: 'find_money_partner_intro' }"
      [skipActionEmit]="false"
    ></ui-nav-exit-back>
  </div>
  <div pre-title>
    <img
      class="partner-intro__image"
      [src]="'https://cdn.gobrightside.com/images/desktop/' + partnerIntro.imagePartner + '.png'"
    />
  </div>
  <div header-title>
    <div class="flex">
      <typography-legacy text-small-regular color="var(--secondary-text)" class="pb-sm">
        {{ partnerIntro.caption | translate }}
      </typography-legacy>
      <typography-legacy title-large color="var(--primary-text)">
        {{ partnerIntro.name | translate }}
      </typography-legacy>
    </div>
  </div>
  <div content-section>
    <typography-legacy color="var(--secondary-text)" style="max-width: 450px">
      {{ partnerIntro.summary | translate }}
    </typography-legacy>

    <typography-legacy text-large-semibold class="mb-sm mt-sm">{{ 'FIND_MONEY_INTRO_BULLETS_HEADER' | translate }}</typography-legacy>
    <div class="flex-row space-between align-center pb-xs" *ngFor="let detail of partnerIntro.details">
      <div class="align-left mr-sm">
        <bw-icon-legacy [iconName]="'arrow_right'" size="24"></bw-icon-legacy>
      </div>
      <div class="flex-column flex-item-flexible">
        <typography-legacy>{{ detail[0] | translate }}</typography-legacy>
      </div>
    </div>
  </div>
  <div footer-actions class="mt-md">
    <button bw-button-legacy (click)="goToPartnerRedirectUrl(partnerIntro)">
      {{ 'CONTINUE_TO_CTA' | translate : { lenderName: partnerIntro.name | translate } }}
    </button>
  </div>
</bw-action-article-legacy>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
